import { getDataWrapper } from './helper'

import { $host } from '.'

export const getTransactions = async () => {
  return getDataWrapper($host.post(`InternalApi/trades/transactions`))
}

export const getBets = async (operation: string, accountId: string) => {
  return getDataWrapper($host.post(`InternalApi/${operation}`, {account_id: accountId}))
}
